import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

const lastEvent = {};

export default class LocationSocketHelper {
  static setUpLocationRealtime (locationId, stationUpdate, stationDeviceUpdate, bookingUpdate, experienceUpdate) {
    const stationObservable = LocationSocketHelper.createEchoObservable('App.Location.' + locationId, '.Station');
    const stationDeviceObservable = LocationSocketHelper.createEchoObservable('App.Location.' + locationId, '.StationDevice');
    const bookingObservable = LocationSocketHelper.createEchoObservable('App.Location.' + locationId, '.Booking');
    const experienceObservable = LocationSocketHelper.createEchoObservable('App.Location.' + locationId, '.Experience');

    stationObservable
      .pipe(
        map(data => data.station),
        distinctUntilChanged((previous, current) => {
          return LocationSocketHelper.distinctUntilChangedCompare(previous, current, 'station');
        }),
      )
      .subscribe(data => stationUpdate(data));

    stationDeviceObservable
      .pipe(
        map(data => data.stationDevice),
      )
      .subscribe(data => stationDeviceUpdate(data));

    bookingObservable
      .pipe(
        map(data => data.booking),
        distinctUntilChanged((previous, current) => {
          return LocationSocketHelper.distinctUntilChangedCompare(previous, current, 'booking');
        }),
      )
      .subscribe(data => bookingUpdate(data));

    experienceObservable
      .pipe(
        map(data => data.experience),
        distinctUntilChanged((previous, current) => {
          return LocationSocketHelper.distinctUntilChangedCompare(previous, current, 'experience');
        }),
      )
      .subscribe(data => experienceUpdate(data));
  }

  static createEchoObservable (channelName, eventName) {
    return new Observable(observer => {
      window.echo.private(channelName)
        .listen(eventName, data => {
          observer.next(data);
        });
      return () => {
        window.echo.leave(channelName);
      };
    });
  }

  // This is a super sepcific throttle, to prevent multiple calls to GQL from the same event.
  static distinctUntilChangedCompare (previous, current, type) {
    const currentTime = new Date().getTime();
    const key = `${type}-${current.id}`;
    if (!lastEvent[key]) {
      lastEvent[key] = currentTime;
      return false;
    }
    const elapsedTimeSinceLastEvent = currentTime - lastEvent[key];

    let shouldBlock = true;
    if (elapsedTimeSinceLastEvent > 200) {
      shouldBlock = false;
    }

    lastEvent[key] = currentTime;
    return shouldBlock;
  }
}
